import React, { useState } from "react";
import { formatMoneda } from "../utils/formatMoneda";
import './CierreTurno.css';
import axios from "../api";
import { formatFechaSegura } from '../services/formatFechaSegura';

const CierreTurnoTable = ({ cierres, onEditar, recargarTabla }) => {
    const [editandoId, setEditandoId] = useState(null);
    const [datosEditados, setDatosEditados] = useState({});
    const [guardando, setGuardando] = useState(false);

    const iniciarEdicion = (id, cierre)=>{
        alert("Estas modificando el cierre con ID: " + id);
        setEditandoId(id);
        setDatosEditados({...cierre});
    };

    const manejarCambio = (e, campo) =>{
        const valor = e.target.value;
        setDatosEditados(pre => ({...pre, [campo]: valor}));
    }

    const cancelarEdicion = () => {
        if (guardando) return;
        setEditandoId(null);
        setDatosEditados({});
    };

    const guardarCambios = async () => {
        setGuardando(true);
        try {
            await axios.patch(`/cierre-turno/${editandoId}`, datosEditados);
            if (recargarTabla) await recargarTabla();
            alert("Registro actualizado con éxito. Cierre de día actualizado.");
            setEditandoId(null);
            setDatosEditados({});
        } catch (error) {
            console.error("Error al guardar cambios:", error);
            alert("Hubo un error al actualizar los datos.");
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div className="table-container">
            <table className="cierre-turno-table">
                <thead>
                    <tr>
                        <th>Cod.Empleado</th>
                        <th>Fecha Ini</th>
                        <th>Total</th>
                        <th>Subtotal</th>
                        <th>Reportado</th>
                        <th>Total Efectivo</th>
                        <th>Estado</th>
                        <th>Id Inicio Turno</th>
                        <th>Id Inicio Dia</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {cierres.map(cierre => {
                        const enEdicion = cierre.id === editandoId;
                        return (
                            <tr key={cierre.id}>
                                <td>{cierre.codEmpleado}</td>
                                <td>{formatFechaSegura(cierre.fechaInicial)}</td>
                                <td className="valor-monetario">{formatMoneda(cierre.total)}</td>
                                <td className="valor-monetario">{formatMoneda(cierre.subtotal)}</td>
                                <td>
                                    {enEdicion ? (
                                        <input
                                            value={datosEditados.reportado || ""}
                                            onChange={(e) => manejarCambio(e, "reportado")}
                                            disabled={guardando}
                                        />
                                    ) : (
                                        formatMoneda(cierre.reportado)
                                    )}
                                </td>
                                <td className="valor-monetario">{formatMoneda(cierre.totalEfectivo)}</td>
                                <td>
                                    {enEdicion ? (
                                        <select
                                            value={datosEditados.estado || ""}
                                            onChange={(e) => manejarCambio(e, "estado")}
                                            disabled={guardando}
                                        >
                                            <option value="1">Activo</option>
                                            <option value="3">Inactivo</option>
                                            <option value="2">Descuadrado</option>
                                        </select>
                                    ) : (
                                        cierre.estado
                                    )}
                                </td>
                                <td>{cierre.idInicioTurno}</td>
                                <td>{cierre.idInicioDia}</td>
                                <td className="acciones-centrado acciones-botones">
                                    {enEdicion ? (
                                        <>
                                            <button
                                                type="button"
                                                onClick={guardarCambios}
                                                className="editar-btn"
                                                disabled={guardando}
                                            >
                                                {guardando ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin" aria-hidden="true" /> Guardando…
                                                    </>
                                                ) : (
                                                    "Guardar"
                                                )}
                                            </button>
                                            <button
                                                type="button"
                                                onClick={cancelarEdicion}
                                                className="cancelar-btn"
                                                disabled={guardando}
                                            >
                                                Cancelar
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={() => iniciarEdicion(cierre.id, cierre)}
                                            className="editar-btn"
                                            disabled={guardando}
                                        >
                                            Editar
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default CierreTurnoTable;
